import NewsTipTable from './NewsTipTable'

export default NewsTipTable
